import {Modal} from "antd";
import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import {setModalVisibility} from "../../../../core/app/setModalVisibility/actions";
import {ModalType} from "../../../../core/models/custom/enums/modalType";
import {ModalVisibilityPayload} from "../../../../core/models/custom/modalVisibility.payload";
import ContentKeys from "../../../../core/utilities/contentKeys";
import {Images} from "../../../../core/utilities/images";
import {IStore} from "../../../../core/utilities/reducers";
import {UI} from "../../../../core/utilities/ui";
import ContentKey from "../../../ContentKey/ContentKey";
import ModalCancelButton from "../../Common/ModalCancelButton/ModalCancelButton";
import ModalHeader from "../../Common/ModalHeader/ModalHeader";
import "./HowToPlayModal.scss";

interface IProps {
  modalVisibilityData: ModalType[];
  setModalVisibility: (payload: ModalVisibilityPayload) => void;
}

const HowToPlayModal = (props: IProps) => {
  const modal = ModalType.DRAWER_HOW_TO_PLAY;
  
  const isVisible = (): boolean => {
    return props.modalVisibilityData.includes(modal);
  }
  
  const handleModalClose = (): void => {
    props.setModalVisibility({modal, isVisible: false});
  }
  
  return (
    <Modal
      className="how-to-play-modal"
      maskStyle={UI.modalMaskStyle()}
      open={isVisible()}
      closable={false}
      footer={false}
      centered
      destroyOnClose
    >
      <ModalHeader
        className="drawer-modal"
        text={<ContentKey contentKey={ContentKeys.HOW_TO_PLAY_POPUP_TITLE}/>}
        icon={<img className="icon" src={Images.drawer_popup_header_how_to_play} alt="icon"/>}
      />
      <div className="body">
        <ContentKey
          className="text-medium"
          contentKey={ContentKeys.HOW_TO_PLAY_POPUP_TEXT}
        />
      </div>
      <ModalCancelButton callback={() => handleModalClose()}/>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setModalVisibility,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    modalVisibilityData: store.setModalVisibility.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HowToPlayModal);
